import { useAuth } from 'reactfire';
import { useAuthUser } from '@react-query-firebase/auth';

export default () => {
  const auth = useAuth();
  const { data, refetch } = useAuthUser(['user'], auth);

  return { data, refetch };
};
